export default (theme) => ({
  font: {
    fontFamily: "realist, sans-serif",
    // color: theme.palette.type === 'dark' ? 'white' : 'black',
  },
});
